import axios from "fetch-api/fetch-api";

export function getDiameterByWidthProfile(width: number, profile: number) {
  return axios.get<string[]>("/get-diameters", {
    params: {
      width,
      profile,
    },
  });
}
